import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
	AfterViewInit
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ShareDataService } from '../../share-data.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';

@Component({
	selector: 'app-trainer-contact-details',
	templateUrl: './contact-details.component.html',
	styleUrls: ['./contact-details.component.css']
})
export class TrainerContactDetailsComponent implements OnInit, AfterViewInit {
	@Input() group: FormGroup;
	personDetails: any;
	isCandidate: any = false;
	currentUserInfo: any;
	currentUserContactDetails: any = {};
	loggedInUser: any;
	parliaments: { code: number; name: string }[];
	// subDistricts: { 'code': number; 'name': string; }[];
	districts: any[];
	villageOptions = [];
	villageOptionsForCommunication = [];
	districtsForCurrentAddress: any[];
	subdistrictsForCurrentAddress: any[];
	districtsList: any[];
	states: any;
	permanentState: any;
	currentState;
	permanantDistrict: any;
	currentDistrict: any;
	subDistricts: any;
	permanentSubDistrict: any;
	currentSubDistrict: any;
	contactDetails: FormGroup;
	isSameAsPermanetAddress = false;
	isChecked = false;
	firstTimeLoding = false;
	firstTimeCommunicationLoading = true;
	parliamentsCommunication = [] ;
	constructor(
		private geographiesService: GeographiesService,
		private shareDataSerice: ShareDataService,
		private currentUserService: CurrentUserService
	) {}

	ngOnInit() {
		this.loggedInUser = this.currentUserService.decodeToken();
		this._getCurrentUser();
		this._checkInitialSameAsPermanentAddress();

		this.firstTimeLoding = false;

	}

		ngAfterViewInit() {
		  if(this.group.get('contactDetails').get('phone').value == 0 ){
				console.log('enterd')
				this.group.get('contactDetails').get('phone').patchValue(null);
			}
	  }
	_checkInitialSameAsPermanentAddress() {

			if (JSON.stringify(this.group.get('contactDetails').get('communicationAddress').value) ===
	         JSON.stringify(this.group.get('contactDetails').get('permanentAddress').value) && this.group.get('contactDetails').get('permanentAddress').get('address1').value !== '' && this.group.get('contactDetails').get('permanentAddress').get('state').value !== '') {
				this.isSameAsPermanetAddress = true;
				this.isChecked = true;
		}
	}

	getPersonalDetails() {
		this.shareDataSerice.getData().subscribe(res => {
			this.personDetails = res;
		});
	}

	isDisabled() {
		if (this.currentUserInfo.role === 'Candidate') {
			return this.isCandidate ? 'true' : 'false';
		}
	}

	_getCurrentUser() {
		console.log('Enter Current');
		this.currentUserService.getAdditionalInfomartion().subscribe(loggedInUser => {
			this.currentUserInfo = loggedInUser;
			console.log(this.group.get('contactDetails').get('phone').value);
			this.group.get('contactDetails').get('permanentAddress').patchValue(loggedInUser.contactDetails.permanentAddress);
			this.getStates();
			console.log(this.group.get('contactDetails').get('phone').value);
			if (this.currentUserInfo.contactDetails.phone <= 10 ){
				console.log('enterd');
				this.group.get('contactDetails').get('phone').patchValue(null);
			}
			console.log(this.group.get('contactDetails'));
			/*if (loggedInUser.contactdetails) {
				if (loggedInUser.contactdetails.phone == 0) {
                       this.group.get('contactDetails').get('phone').patchValue(null);
					   console.log( this.group.get('contactDetails').value);
				}else if (loggedInUser.contactdetails.phone) {
                this.group.get('contactDetails').get('phone').patchValue(loggedInUser.contactdetails.phone);
				console.log( this.group.get('contactDetails').value);
				}

			}*/


		});
	}

	// getCurrentUserAdditionalInfo() {
	// 	this.currentUserService.getAdditionalInfomartion().subscribe(
	// 		res => {
	// 			this.currentUserInfo = res;
	// 			this.currentUserContactDetails = this.currentUserInfo.contactDetails;
	// 			// console.log(this.currentUserInfo);
	// 		},
	// 		error => {
	// 			console.log(`Error in fetching data. ${error}`);
	// 		}
	// 	);
	// }

	getStates() {
		console.log('Enteredd States');
		this.geographiesService.getStates().subscribe(
			states => {
				this.states = states.states;
				this.getInitialDistrictForPermanentCurrentAddress();
			},
			error => {
				console.log('Error in fetching states : ', error);
			}
		);
	}

	getInitialDistrictForPermanentCurrentAddress() {
			if (this.group.get('contactDetails').get('permanentAddress').get('state').value) {
				this.firstTimeLoding = true;
					this.getDistrictForPermanentAddress();
			}

			if (this.group.get('contactDetails').get('communicationAddress').get('state').value) {
					this.getDistrictForCurrentAddress();
			}
	}

	getDistrictForPermanentAddress() {
		this.districts = [];
		if (!this.firstTimeLoding) {
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('district').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('districtId').setValue(null);
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrict').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrictId').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrict').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrictId').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('city').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('parliamentaryConstituency').setValue('');
		}
		if (this.states !== undefined) {
			this.permanentState = this.states.find(
				elements =>
					elements.name === this.group.get('contactDetails').get('permanentAddress').get('state').value
			);
			this.group.get('contactDetails').get('permanentAddress').get('stateId').setValue(this.permanentState.code);
			this.getDistrictsInTheState(this.permanentState.code, 'permanent');
			this.getParliaments(this.permanentState.code);
		}
	}

	showSelected(item, formControlValue): boolean {
		if (item && formControlValue) {
			return (
				item === formControlValue || item.code === formControlValue.code
			);
		} else {
			return false;
		}
	}

	getDistrictForCurrentAddress() {
		console.log('Entered Current District');

		this.districtsForCurrentAddress = [];
			if (!this.firstTimeCommunicationLoading && !this.isChecked) {
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('district').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('districtId').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrict').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrictId').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrict').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrictId').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('city').setValue('');
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('parliamentaryConstituency').setValue('');
		}
		if (this.states !== undefined) {
			this.currentState = this.states.find(
				elements =>
					elements.name ===
					this.group.get('contactDetails').get('communicationAddress').get('state').value
			);
			if (this.currentState.code) {
				this.group.get('contactDetails').get('communicationAddress').get('stateId').setValue(this.currentState.code);
			}
			this.getDistrictsInTheState(this.currentState.code, 'current');
			this.getParliamentCommunication(this.currentState.code);
		}
		// this.getDistrictsInTheState(this.group.get('contactDetails').get('communicationAddress').get('state').value.code, 'current');
	}

	getDistrictsInTheState(district, type) {
		this.geographiesService.getDistricts(district).subscribe(
			districts => {
				if (type === 'permanent') {
					this.districts = districts.districts;
					this.getSubDistrictsInDistrictsForPermanentAddress();
				} else {
					this.districtsForCurrentAddress = districts.districts;

					this.getSubDistrictsInDistrictsForCurrentAddress();
				}
			},
			error => {
				console.log(`Error while fetching districts : ${error}`);
			}
		);
	}

	getSubDistrictsInDistrictsForPermanentAddress() {
		console.log('Enter');
		if (!this.firstTimeLoding) {
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrict').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrictId').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrict').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrictId').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('city').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('parliamentaryConstituency').setValue('');
		}
		this.permanantDistrict = this.districts.find(
			elements =>
				elements.name ===
				this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('district').value
		);
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('districtId').patchValue(this.permanantDistrict.code);

		this.getSubDistrictsInTheDistrict(this.permanantDistrict.code, 'permanent');
	}

	getSubDistrictsInDistrictsForCurrentAddress() {
		if (!this.firstTimeCommunicationLoading && !this.isChecked ) {
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrict').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrictId').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrict').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrictId').setValue(null);
		this.group.get('contactDetails').get('communicationAddress').get('city').setValue('');
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('parliamentaryConstituency').setValue(null);
		}
		this.findCurrentCommunicationDistrict();
		this.getSubDistrictsInTheDistrict(this.currentDistrict.code, 'current');
	}
	findCurrentCommunicationDistrict() {
		this.currentDistrict = this.districtsForCurrentAddress.find(
			elements =>
				elements.name ===
				this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('district').value
		);
		if (this.currentDistrict.code) {
			this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('districtId').patchValue(this.currentDistrict.code);
		}
	}
	getSubDistrictsInTheDistrict(district, type) {
		this.geographiesService.getTehsil(district).subscribe(
			districts => {
				if (type === 'permanent') {
					this.subDistricts = districts.subDistricts;
					this.getVillagesInSubDistrictforPemanent();
				} else {
					this.subdistrictsForCurrentAddress = districts.subDistricts;
					this.getVillagesInSubDistrictforCurrent();
				}
			},
			error => {
				console.log(`Error while fetching districts : ${error}`);
			}
		);
	}

	getVillagesInSubDistrictforPemanent() {
		if (!this.firstTimeLoding) {
		this.group.get('contactDetails').get('permanentAddress').get('city').setValue('');
		this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('parliamentaryConstituency').setValue('');
		}else {
			this.firstTimeLoding = false;
		}
		this.permanentSubDistrict = this.subDistricts.find(
			elements =>
				elements.name ===
				this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrict').value
		);
		this.group.get('contactDetails').get('permanentAddress').
		get('districtDetails').get('subDistrictId').setValue(this.permanentSubDistrict.code.toString());
		this.geographiesService.getVillages(
			this.group.get('contactDetails').get('permanentAddress').get('districtDetails').get('subDistrictId').value
			)
			.subscribe(res => {
				this.villageOptions = res.villages;
			});
	}

	getVillagesInSubDistrictforCurrent() {
		if (!this.firstTimeCommunicationLoading && !this.isChecked) {
		this.group.get('contactDetails').get('communicationAddress').get('city').setValue('');
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('parliamentaryConstituency').setValue(null);
		}else {
			this.firstTimeCommunicationLoading = false;
		}
		this.findCurrentCommunicationSubDistrict();
		if (this.currentSubDistrict.code) {
			this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrictId').setValue(this.currentSubDistrict.code.toString());
		} else {
		}
		this.geographiesService.getVillages(this.currentSubDistrict.code).subscribe(res => {
				this.villageOptionsForCommunication = res.villages;
			});
	}
	findCurrentCommunicationSubDistrict() {
		this.currentSubDistrict = this.subdistrictsForCurrentAddress.find(
			elements =>
				elements.name ===
				this.group
					.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrict').value
		);
	}
	getParliaments(stateID) {
		this.geographiesService.getParliamentaryConstituenciess(stateID).subscribe(res => {
				this.parliaments = res.constituencyDetails;
			});
	}
	getParliamentCommunication(stateID) {
		this.geographiesService.getParliamentaryConstituenciess(stateID).subscribe(res => {
				this.parliamentsCommunication = res.constituencyDetails;
			});
	const element	=	this.parliamentsCommunication.find(
			elements =>
		elements.name === this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('parliamentaryConstituency').value
		);
		this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('parliamentaryConstituency').setValue(element.name);
	}

	workAsPermanentAddress(checked) {
		this.isChecked = checked;
		if (checked === true) {
			this.getDistrictsInTheState(this.group.get('contactDetails').get('permanentAddress').get('stateId').value, 'current');
			// this.getParliamentCommunication(this.group.get('contactDetails').get('permanentAddress').get('stateId').value);
			Helpers.copyArray(this.parliamentsCommunication, this.parliaments);
			// this.parliamentsCommunication = this.parliaments;
		// 	this.group.get('contactDetails').get('communicationAddress').disable();
			this.group.get('contactDetails').get('communicationAddress').patchValue(
					this.group.get('contactDetails').get('permanentAddress').value
				);

		} else {
			this.group.get('contactDetails').get('communicationAddress').reset();
						this.group.get('contactDetails').get('communicationAddress').get('country').setValue('India');
			this.group.get('contactDetails').get('communicationAddress').get('countryId').setValue('91');
			/*this.group.get('contactDetails').get('communicationAddress').get('pincode').setValue('');
			this.group.get('contactDetails').get('communicationAddress').get('address1').setValue('');

			this.group.get('contactDetails').get('communicationAddress').get('state').setValue('');
			this.group.get('contactDetails').get('communicationAddress').get('stateId').setValue('');
			this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('district').setValue('');
			this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('districtId').setValue('');
			this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrict').setValue('');
			this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('subDistrictId').setValue('');
			this.group.get('contactDetails').get('communicationAddress').get('districtDetails').get('parliamentaryConstituency').setValue('');*/
			this.group.get('contactDetails').get('communicationAddress').get('city').setValue('');
		}
	}
}
